'use strict';

var getRandomId = require('./random-id.js');
var extend = require('xtend');

module.exports = createPayload;

function createPayload(data) {
  return extend({
    // defaults
    id: getRandomId(),
    jsonrpc: '2.0',
    params: []
    // user-specified
  }, data);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ledgerhq/web3-subprovider/node_modules/web3-provider-engine/dist/es5/util/create-payload.js
// module id = 473
// module chunks = 0